<template>
    <span class="inline-flex items-center gap-0.5">
        <template v-for="(key, i) in parsedKeys" :key="i">
            <span v-if="i > 0" :class="separatorClass">+</span>
            <kbd :class="kbdClass">{{ key }}</kbd>
        </template>
    </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(defineProps<{
    keys: string;
    size?: 'sm' | 'base';
    tone?: 'boxed' | 'inline';
}>(), {
    size: 'base',
    tone: 'boxed',
});

const symbolMap: Record<string, string> = {
    ArrowLeft: '←',
    ArrowRight: '→',
    ArrowUp: '↑',
    ArrowDown: '↓',
    Escape: 'Esc',
};

const kbdClass = computed(() => {
    if (props.tone === 'inline') {
        return props.size === 'sm' ? 'font-mono text-[10px] leading-none' : 'font-mono text-xs leading-none';
    }
    return props.size === 'sm' ? 'kbd-shortcut kbd-shortcut--sm' : 'kbd-shortcut';
});

const separatorClass = computed(() => {
    const sizeCls = props.size === 'sm' ? 'text-[10px]' : 'text-xs';
    const colorCls = props.tone === 'inline' ? 'opacity-60' : 'text-gray-400 dark:text-gray-500';
    return `${sizeCls} ${colorCls}`;
});

const parsedKeys = computed(() => {
    return props.keys.split('+').map((key) => {
        const trimmed = key.trim();
        return symbolMap[trimmed] ?? trimmed;
    });
});
</script>
